import React, { useContext } from "react";
import {
    Label,
    Wrapper,
    SingleValueWrapper,
    OptionWrapper,
} from "./styled.js";
import SelectAsync from 'react-select/lib/Async';
import { fetchLocations } from "./service";
import { AppContext } from "hocs/withAppContext";

const SingleValue = ({ innerProps, innerRef, data }) =>
    <SingleValueWrapper ref={innerRef} {...innerProps}>
        {data.stringName}
    </SingleValueWrapper>;

const Option = ({ innerProps, innerRef, data }) =>
    <OptionWrapper ref={innerRef} {...innerProps} data-root={data.rootLocation}>
        <div>
            <p>{data.stringName}</p>
            {data.stringAddress && <p>{data.stringAddress}</p>}
        </div>
    </OptionWrapper>;

export const SelectLocation = ({ label, placeholder, required,
                                   value = '', onChange, error,
                                   disabled }) => {
    const { role } = useContext(AppContext);
    const roleId = role.objectId;

    return <Wrapper className="select-box">
        {label && <Label required={required}>{label}</Label>}
        <SelectAsync
            className={ error ? 'data-error': ''}
            classNamePrefix="react-select"
            placeholder={placeholder}
            required={required}
            defaultOptions={true}
            loadOptions={q => fetchLocations(roleId, q)}
            components={{ SingleValue, Option }}
            isClearable={true}
            value={value}
            onChange={onChange}
            isDisabled={disabled}
        />
    </Wrapper>
};

export default SelectLocation;
